import { Class as IClass, getClass, getClassesPaths } from "@models/class.model";
import { getGlobals } from "@models/globals.model";
import { Sanity } from "@models/sanity.model";
import { GetStaticPropsContext, NextPage } from "next";
import Layout from "@components/layout";
import CatalogSidebar from "@components/catalog-sidebar";
import CatalogDetail from "@components/catalog-detail";
import { classesSlug } from "@utils/routes";

export interface ClassPageProps extends Sanity.PageProps {
  classPage: IClass;
}

const Class: NextPage<ClassPageProps> = ({ globals, classPage }) => {
  const { hide_header_banner, hero_media, title, body, accordian, seo } = classPage ?? {};
  const sidebarHeading = "Explore all workouts";

  return (
    <Layout globals={globals} hideBanner={hide_header_banner} seo={seo}>
      <CatalogSidebar listButtonText={sidebarHeading} backLink={classesSlug} />
      <CatalogDetail heroMedia={hero_media} heading={title} accordion={accordian} body={body} />
    </Layout>
  );
};

export default Class;

export async function getStaticProps(context: GetStaticPropsContext) {
  /**
   * We suffix 'class' with 'page' since we can't use the JS class keyword.
   */
  const [globals, classPage] = await Promise.all([
    await getGlobals(),
    await getClass(String(context.params?.slug)),
  ]);

  return {
    props: {
      globals,
      classPage,
    },
  };
}

export async function getStaticPaths() {
  const paths = await getClassesPaths();
  return { paths, fallback: false };
}
